var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            width: "70%",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "flex-wrap": "wrap" },
                  attrs: { type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "套餐:", prop: "" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.inputForm.cecUnmSets.nameCn)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "名称（英）:",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "名称（英）不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写名称（英）",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名称（中）:", prop: "" } },
                        [_c("span", [_vm._v(_vm._s(_vm.inputForm.nameCn))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "标签",
                            prop: "tagsIds",
                            rules: [
                              {
                                required: true,
                                message: "标签不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("tagSelect", {
                            ref: "tagSelectRef",
                            attrs: {
                              value: _vm.inputForm.tagsIds,
                              associationType: "3",
                            },
                            on: { searchChange: _vm.handSelect },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "简介（英）:",
                            prop: "introductionEn",
                            rules: [
                              {
                                required: true,
                                message: "简介不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写简介内容",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.inputForm.introductionEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introductionEn", $$v)
                              },
                              expression: "inputForm.introductionEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "简介（中）:",
                            prop: "",
                            rules: [
                              {
                                required: true,
                                message: "简介不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              autosize: { minRows: 5 },
                              placeholder: "请填写简介内容",
                              maxlength: "255",
                            },
                            model: {
                              value: _vm.inputForm.introduction,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "introduction", $$v)
                              },
                              expression: "inputForm.introduction",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "功能空间:",
                            prop: "functionSpacePositionIds",
                            rules: [
                              {
                                required: true,
                                message: "功能空间不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            ref: "gridselectRef",
                            attrs: {
                              title: "选择功能空间",
                              labelName: "nameEn",
                              disabled: _vm.method === "view",
                              showType: "table",
                              labelValue: "id",
                              value: _vm.inputForm.functionSpacePositionIds,
                              limit: 10,
                              columns: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              dataListUrl:
                                "/unmspace/cecUnmFunctionalSpace/list",
                              queryEntityUrl:
                                "/unmspace/cecUnmFunctionalSpace/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.functionSpacePositionIds = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      class: _vm.inputForm.showGallery == "0" ? "opacity5" : "",
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "展览集:",
                            prop: "gallery",
                            rules: [
                              {
                                required:
                                  _vm.inputForm.showGallery == "1"
                                    ? true
                                    : false,
                                message: "展览集不能为空",
                                trigger: "change",
                              },
                            ],
                          },
                        },
                        [
                          _c("ImageUploadDraggableBtn", {
                            attrs: {
                              draggable: true,
                              itemActivityForm: true,
                              ifSetUploadName: true,
                              ownerId: _vm.inputForm.id,
                              uploadInfo: {
                                type: "postionImage",
                                title: "展览集",
                                category: "sets",
                                categoryName: "套餐空间",
                                tip: "请先输入英文名称",
                                fileName: _vm.inputForm.nameEn,
                              },
                              disabled: false,
                              action: "/unmfile/cecUnmFileupload",
                              tip: "单个图片不要超过10M,可拖动列表行排序",
                            },
                            on: {
                              updateChange: function ($event) {
                                return _vm.handImageList($event, "gallery")
                              },
                            },
                            model: {
                              value: _vm.inputForm.gallery,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "gallery", $$v)
                              },
                              expression: "inputForm.gallery",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "medium",
                    type: "danger",
                    icon: "el-icon-close",
                  },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "medium",
                        type: "success",
                        icon: "el-icon-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }